const notCancellableReasons = {
  dispatachedTimeout: 'DISPATCHED_OVER_48_HOURS',
  enclosed: 'ENCLOSED',
  driveaway: 'DRIVEAWAY',
  bundled: 'BUNDLED',
  invalidStatus: 'INVALID_STATUS',
};

export default notCancellableReasons;
